import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Researcher } from "../../../../model/researcher";

@Component({
  selector: 'aw-create-researcher',
  templateUrl: './create-researcher-dialog.component.html',
  styleUrls: ['./create-researcher-dialog.component.scss']
})
export class CreateResearcherDialogComponent implements OnInit {


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Researcher,
    public dialogRef: MatDialogRef<CreateResearcherDialogComponent>
  ) {


  }

  ngOnInit(): void {

  }


}


